import { apiFetch } from '@/shared/api/client'
import { isMockApi } from '@/shared/env'

export type GenerateDeliveryLine = {
  productName: string
  productionDate: string
  qty: number
}

export type HeldDeliveryLine = {
  productName: string
  needQty: number
  reason: 'no_stock' | string
}

export type GeneratedDelivery = {
  delivery_id: string
  delivery_code: string
  store_name: string
  trip_date?: string
  updated_at: string
  lines: GenerateDeliveryLine[]
  heldLines?: HeldDeliveryLine[]
}

export type SkippedOutlet = {
  store_name: string
  reason: string
}

export type GenerateDeliveriesResponse = {
  deliveries: GeneratedDelivery[]
  skipped_outlets?: SkippedOutlet[]
}

export type GenerateDeliveriesRequest = {
  deviceId: string
  outletNames: string[]
  delmanName: string
  /** YYYY-MM-DD — hari ini atau besok */
  tripDate?: string
}

export async function generateDispatchDeliveries(
  req: GenerateDeliveriesRequest,
): Promise<GenerateDeliveriesResponse> {
  if (isMockApi) {
    throw new Error('Generate distribusi membutuhkan koneksi API.')
  }

  return apiFetch<GenerateDeliveriesResponse>('/kitchen/deliveries/generate', {
    method: 'POST',
    body: JSON.stringify({
      outlet_names: req.outletNames,
      delman_name: req.delmanName,
      trip_date: req.tripDate,
    }),
  })
}
